import { GlobalRouter } from '@okapi/router-react';
import { combineReducers } from 'redux';
import { createReducer as createCookieReducer } from 'isomorphic-redux-cookie-middleware';
import { createReducer as createRouterReducer } from '@okapi/router-connect';
import { createReducer } from 'typesafe-actions';
import { featuresReducer } from 'features';
import { errorsHookReducer } from 'features/errors-hook';
import { Layers } from './header-middleware/types';
import { ReturnValueDeviceType } from 'entries/server/utils';

export type Env = {
  API_KEY?: string;
  CDN_HOST?: string;
  CLIENT_LOG_LEVEL?: string;
  EXPERIMENTS_DOMAIN?: string;
  FLOWBOX_KEY?: string;
  LOG_LEVEL?: string;
  MEDIA_CLOUDINARY_CLOUD: string;
  ORCHESTRATOR_BACKEND_HOST: string;
  ORCHESTRATOR_HOST: string;
  ORCHESTRATOR_HOST_KZ?: string;
  PRODUCTS_COMPARE_LISTS_LIMIT: number;
  PRODUCTS_COMPARE_LIST_LIMIT: number;
  PRODUCTS_COMPARE_ORCHESTRATOR_BACKEND_HOST: string;
  PRODUCTS_COMPARE_ORCHESTRATOR_HOST: string;
  PRODUCTS_COMPARE_ORCHESTRATOR_HOST_KZ: string;
  REMOTE_TIMEOUT?: number;
  ROBOTINT_CLIENT_ID: string;
  ROBOTINT_LINK: string;
  ROBOTINT_SECRET: string;
  SERVER_FETCH_DATA_TIMEOUT: number;
  USE_APPSFLYER?: boolean;
  USE_CREDENTIALS: boolean;
  USE_GROUP_RATINGS?: boolean;
  USE_REMOTES?: boolean;
  USE_REVIEW_FORM_REMOTE?: boolean;
  requestID: string;
  requestUrl?: string;
};

export const rootReducer = ({
  host,
  globalRouter,
  isBot,
  env,
  userAgent,
  deviceType,
  cookie,
  layers,
  uuid,
}: {
  host: string;
  globalRouter: GlobalRouter;
  isBot: boolean;
  env: Env;
  userAgent: string;
  deviceType: ReturnValueDeviceType;
  cookie: string;
  layers: Layers;
  uuid?: string;
}) =>
  combineReducers({
    pdp: featuresReducer,
    router: createRouterReducer(globalRouter),
    host: createReducer(host),
    isBot: createReducer(isBot),
    deviceType: createReducer(deviceType),
    env: createReducer(env),
    userAgent: createReducer(userAgent),
    cookie: createReducer(cookie),
    cookieParsed: createCookieReducer(cookie),
    layers: createReducer(layers),
    errorsHook: errorsHookReducer,
    experimentsUUID: createReducer(uuid),
  });

export type RootReducer = ReturnType<ReturnType<typeof rootReducer>>;
